import { REGEX_PATTERNS } from '@/shared/config/common/constants/patterns';
import type { ValidationInput } from '@/shared/ui/input/input';

export const iinValidation: ValidationInput[] = [
  {
    settings: {
      type: 'minlength',
      num: 12,
    },
    message: 'bookingPage.message.iin',
  },
  {
    settings: {
      type: 'isDigit',
      num: 12,
    },
    message: 'bookingPage.message.number',
  },
];

export const fioValidation: ValidationInput[] = [
  {
    settings: {
      type: 'minlength',
      num: 3,
    },
    message: 'bookingPage.message.fio',
  },
  {
    settings: {
      type: 'words-count',
      min: 2,
    },
    message: 'bookingPage.message.fio',
  },
  {
    settings: {
      type: 'pattern',
      pattern: REGEX_PATTERNS.FULL_NAME_2,
    },
    message: 'bookingPage.message.correct_fio',
  },
];

export const surnameValidation: ValidationInput[] = [
  {
    settings: {
      type: 'minlength',
      num: 3,
    },
    message: 'bookingPage.message.fio',
  },
  {
    settings: {
      type: 'pattern',
      pattern: REGEX_PATTERNS.FULL_NAME_2,
    },
    message: 'bookingPage.message.correct_fio',
  },
];

export const nameValidation: ValidationInput[] = [
  {
    settings: {
      type: 'minlength',
      num: 2,
    },
    message: 'bookingPage.message.fio',
  },
  {
    settings: {
      type: 'pattern',
      pattern: REGEX_PATTERNS.FULL_NAME_2,
    },
    message: 'bookingPage.message.correct_fio',
  },
];
